import { Row, Typography } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.less";
import { useSelector } from "react-redux";
import { StoreState } from "../../redux/store";
import BlockFanConfirmationModalComponent from "../BlockFanConfirmationModalComponent/BlockFanConfirmationModalComponent";
import CancelSubscriptionConfirmationModalComponent from "../CancelSubscriptionConfirmationModalComponent/CancelSubscriptionConfirmationModalComponent";

type props = {
  isOpen: boolean;
  hideShareButton?: boolean;
  hideCancelSubButton?: boolean;
  hideBlockButton?: boolean;
  onClose?: () => void;
  onPrivateGalleryClick?: () => void;
  onShareProfileClick?: () => void;
  onCancelSubscriptionClick?: () => void;
  onBlockFanClick?: () => void;
  isBlocked?: boolean;
  isCancellingSubscription?: boolean;
};

const ConversationThreeDotsModalComponent: React.FC<props> = ({
  isOpen,
  hideShareButton,
  hideCancelSubButton,
  hideBlockButton,
  onClose,
  onPrivateGalleryClick,
  onShareProfileClick,
  onCancelSubscriptionClick,
  onBlockFanClick,
  isBlocked = false,
  isCancellingSubscription = false,
}) => {
  const { t } = useTranslation();
  const [isBlockFanModalOpen, setIsBlockFanModalOpen] = useState<boolean>(false);
  const [isCancelSubscriptionModalOpen, setIsCancelSubscriptionModalOpen] = useState<boolean>(false);
  const selectedConversation = useSelector((state: StoreState) => state.messages.selectedConversation);

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <>
      <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
        <div className="bottom-modal-content" onClick={handleModalClick}>
          <Row className="w-full justify-content-center mt-10">
            <div className="header-icon-grey" onClick={handleOverlayClick}></div>
          </Row>
          <div className="bottom-modal-header">
            <Typography.Text className="bottom-modal-title">{t("what-action-do-you-want-to-take")}</Typography.Text>
          </div>
          <div className="bottom-modal-body">
            {!hideShareButton && (
              <button className="bottom-modal-button" onClick={onShareProfileClick}>
                <Typography.Text className="bottom-modal-button-title">{t("share-profile-via")}</Typography.Text>
              </button>
            )}

            <button className="bottom-modal-button mt-14" onClick={onPrivateGalleryClick}>
              <Typography.Text className="bottom-modal-button-title">{t("private-gallery")}</Typography.Text>
            </button>

            {!hideCancelSubButton && (
              <button className="bottom-modal-button mt-14" onClick={() => setIsCancelSubscriptionModalOpen(true)}>
                <Typography.Text className="bottom-modal-button-title">{t("cancel-subcription-label")}</Typography.Text>
              </button>
            )}

            {!hideBlockButton && (
              <button
                className="bottom-modal-button mt-14"
                onClick={() => {
                  if (isBlocked) return onBlockFanClick?.();
                  setIsBlockFanModalOpen(true);
                }}
              >
                <Typography.Text className="bottom-modal-button-title">
                  {isBlocked ? t("unblock") : t("block")} {selectedConversation?.interlocutor?.name}
                </Typography.Text>
              </button>
            )}

            <button className="bottom-modal-cancel-button" onClick={onClose}>
              <Typography.Text className="bottom-modal-cancel-button-title">{t("cancel")}</Typography.Text>
            </button>
          </div>
        </div>
      </div>

      {!hideBlockButton && isBlockFanModalOpen && (
        <BlockFanConfirmationModalComponent isOpen={isBlockFanModalOpen} onClose={() => setIsBlockFanModalOpen(false)} blockFan={onBlockFanClick!} />
      )}
      {!hideCancelSubButton && isCancelSubscriptionModalOpen && (
        <CancelSubscriptionConfirmationModalComponent
          isOpen={isCancelSubscriptionModalOpen}
          onClose={() => setIsCancelSubscriptionModalOpen(false)}
          cancelSubscription={onCancelSubscriptionClick!}
          isLoading={isCancellingSubscription}
        />
      )}
    </>
  );
};

export default ConversationThreeDotsModalComponent;
